import { message, notification } from "antd";
import { apiCallback } from "./Common";
import {
  APIResponseStatus,
  ConfigActions,
  ConfigEntity,
} from "../Constants/Constants";
import {
  convertGroupConfigFormToApi,
  convertDeviceConfigFormToApi,
  convertDeviceModelConfigFormToApi,
  convertServiceConfigFormToApi,
  convertServiceProviderConfigFormToApi,
} from "../Helpers/ConfigHelpers";

const getMessage = (action, success) => {
  if (success) {
    return `Configuration ${
      action === ConfigActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === ConfigActions.add ? "adding" : "updating"
  } Configuration`;
};

const getFormattedData = (entity, values, action) => {
  switch (entity) {
    case ConfigEntity.deviceModel:
      return convertDeviceModelConfigFormToApi(values, action);
    case ConfigEntity.service:
      return convertServiceConfigFormToApi(values, action);
    case ConfigEntity.provider:
      return convertServiceProviderConfigFormToApi(values, action);
    case ConfigEntity.device:
      return convertDeviceConfigFormToApi(values, action);
    case ConfigEntity.group:
      return convertGroupConfigFormToApi(values, action);
    default:
      console.log("Error: entity not found!");
  }
};

const callApiFunction = (entity, props, formattedData, formSubmitCallback) => {
  const { action, configManagementApi } = props;
  switch (entity) {
    case ConfigEntity.deviceModel:
      if (action === ConfigActions.add) {
        return configManagementApi.createDeviceModelConfig(
          formattedData,
          formSubmitCallback
        );
      }
      return configManagementApi.updateDeviceModelConfig(
        formattedData,
        formSubmitCallback
      );
    case ConfigEntity.service:
      if (action === ConfigActions.add) {
        return configManagementApi.createServiceConfig(
          formattedData,
          formSubmitCallback
        );
      }
      return configManagementApi.updateServiceConfig(
        formattedData,
        formSubmitCallback
      );
    case ConfigEntity.provider:
      if (action === ConfigActions.add) {
        return configManagementApi.createProviderConfig(
          formattedData,
          formSubmitCallback
        );
      }
      return configManagementApi.updateProviderConfig(
        formattedData,
        formSubmitCallback
      );
    case ConfigEntity.device:
      if (action === ConfigActions.add) {
        return configManagementApi.createDeviceConfig(
          formattedData,
          formSubmitCallback
        );
      }
      return configManagementApi.updateDeviceConfig(
        formattedData,
        formSubmitCallback
      );
    case ConfigEntity.group:
      if (action === ConfigActions.add) {
        return configManagementApi.createGroupConfig(
          formattedData,
          formSubmitCallback
        );
      }
      return configManagementApi.updateGroupConfig(
        formattedData,
        formSubmitCallback
      );
    default:
      console.log("Error in create/update api!");
      throw new Error("Error in create/update api!");
  }
};

export const onFormSubmit =
  ({ entity, props, setProcessing, setInitialValues }) =>
  (values) => {
    const { history, action, record } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);
    const formSubmitCallback = apiCallback({
      history,
      preProcess: () => setProcessing(false),
      errorCallback: (error) => message.error(failMessage),

      successCallback: (data) => {
        if (
          data.status.toLowerCase() === APIResponseStatus.fail.toLowerCase()
        ) {
          if (data.info.includes("Duplicate-Name-For-Config")) {
            notification["error"]({
              message: `Error creating Configuration`,
              description: `Configuration name already exist.`,
            });
          } else if (data.info.includes("Config-Already-Present")) {

            notification["error"]({
              message: `Error creating Configuration`,
              description: `Configuration for selection already exist.`,
            });
          } else {
            message.error(failMessage);
          }
        } else {
          setInitialValues(values);
          message.success(successMsg);
          props.onSubmit({ redirect: action === ConfigActions.add });
        }
      },
    });
    try {
      setProcessing(true);
      values.configId = record?.configId;
      const formattedData = getFormattedData(entity, values, action);
      console.log("onSubmit formattedData", formattedData);
      callApiFunction(entity, props, formattedData, formSubmitCallback);
    } catch (error) {
      console.log("Api Error", error);
      message.error(failMessage);
      setProcessing(false);
    }
  };
